import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import "./GroupBy.css";

function GroupBy({ filteredStatuses, selectedProjectFilter, setSelectedProjectFilter }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const filterProRef = useRef(null);

  const handleClickOutClient = (event) => {
    if (filterProRef.current && !filterProRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutClient);
    } else {
      document.removeEventListener("mousedown", handleClickOutClient);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutClient);
    };
  }, [dropdownOpen]);

  return (
    <div
      className="isecurion_project_filter_container"
      ref={filterProRef}>
      <div className="isecurion_project_filter_heading">
        <span>Group by</span>
        <span style={{marginLeft:"-5px"}}>{selectedProjectFilter}</span>
        <Icon
          icon={dropdownOpen ? "ic:round-arrow-drop-up" : "ic:round-arrow-drop-down"}
          width="24"
          height="24"
          style={{ color: "#E76A34", cursor: "pointer" }}
          onClick={() => setDropdownOpen(!dropdownOpen)}
        />
      </div>

      {dropdownOpen && (
        <>
          <ul className="custom-dropdown" style={{ marginTop: "-14px", marginLeft: "10px" }}>
            {filteredStatuses?.map((status) => (
              <li
                key={status}
                onClick={() => {
                  setSelectedProjectFilter(status);
                  setDropdownOpen(false);
                }}
              >
                {status}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}

export default GroupBy;
